import Icon from '@ant-design/icons'
import * as React from 'react'

import { NovaIconProps } from '../types/iconTypes'

const Warning = (props: NovaIconProps) => (
  <Icon
    {...props}
    component={() => (
      <svg
        width="1em"
        height="1em"
        focusable={false}
        viewBox="2 2 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M29.7291 25.0099L29.7331 25.0079L17.7372 4.00741L17.7292 4.0114C17.3844 3.40976 16.7437 3 16.0001 3C15.2566 3 14.616 3.40976 14.2712 4.0114L14.2633 4.00741L2.2673 25.0079L2.27132 25.0099C2.10342 25.3028 1.99951 25.6376 1.99951 25.9993C1.99951 27.1037 2.89496 27.9992 3.99931 27.9992H27.9992C29.1035 27.9992 29.9989 27.1037 29.9989 25.9993C29.9999 25.6376 29.897 25.3038 29.7291 25.0099ZM4.00626 26.0223C4.03025 25.9814 4.05227 25.9394 4.07226 25.8974L15.9023 5.18671C15.9373 5.13773 15.9703 5.08776 16.0012 5.03579C16.0302 5.08576 16.0611 5.13373 16.0931 5.17971L27.9951 26.0173L4.00626 26.0223ZM14.9999 13.0157C14.9999 12.4635 15.4476 12.0157 15.9999 12.0157C16.5522 12.0157 16.9999 12.4635 16.9999 13.0157V19.0157C16.9999 19.568 16.5522 20.0157 15.9999 20.0157C15.4476 20.0157 14.9999 19.568 14.9999 19.0157V13.0157ZM15.9999 21.2657C15.3095 21.2657 14.7499 21.8254 14.7499 22.5157C14.7499 23.2061 15.3095 23.7657 15.9999 23.7657C16.6902 23.7657 17.2499 23.2061 17.2499 22.5157C17.2499 21.8254 16.6902 21.2657 15.9999 21.2657Z"
          fill="currentColor"
        />
      </svg>
    )}
  />
)

export default Warning
